import { Routes, Route } from 'react-router-dom';
import { AdminLayout } from './AdminLayout';
import { AdminOverview } from './AdminOverview';
import { AdminUsersManager } from './AdminUsersManager';
import { AdminSettings } from './AdminSettings';
import { AdminSystemHealth } from './AdminSystemHealth';
import { AdminReports } from './AdminReports';
import { AdminFinance } from './AdminFinance';
import { AdminRefunds } from './AdminRefunds';
import { AdminLogs } from './AdminLogs';

export function AdminApp() {
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<AdminOverview />} />
        <Route path="/users" element={<AdminUsersManager />} />
        <Route path="/reports" element={<AdminReports />} />
        <Route path="/finance" element={<AdminFinance />} />
        <Route path="/refunds" element={<AdminRefunds />} />
        <Route path="/logs" element={<AdminLogs />} />
        <Route path="/settings" element={<AdminSettings />} />
        <Route path="/health" element={<AdminSystemHealth />} />
      </Routes>
    </AdminLayout>
  );
}
